import * as actionTypes from "../ActionTypes";

const initialState = {
  churches: [],
  selectedChurch: null,
  featuredChurches: [], 
  loading: false,
  error: null,
  featuredLoading: false,
  featuredError: null, 
  favouriteChurches: [],
  favouriteLoading: false,
  favouriteError: null,
  homeChurches: [], 
  homeLoading: false,
  homeError: null, 
  nearbyChurches: [], 
  nearbyLoading: false,
  nearbyError: null, 
};

const churchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CHURCHES_READ_REQUEST:
      return { ...state, loading: true, error: null };

    case actionTypes.CHURCHES_READ_SUCCESS:
      return {
        ...state,
        loading: false,
        churches: action.payload?.data || [],
        selectedChurch:
          action.payload?.data?.length === 1
            ? action.payload.data[0]
            : null,
      };

    case actionTypes.CHURCHES_READ_FAIL:
      return { ...state, loading: false, error: action.payload };
      case actionTypes.LIKE_CHURCH_REQUEST:
        return { ...state, loading: true };
      
      case actionTypes.LIKE_CHURCH_SUCCESS:
        return {
          ...state,
          loading: false,
          // update home church if needed
          selectedChurch: action.payload?.data || state.selectedChurch,
        };
      
    case actionTypes.LIKE_CHURCH_FAIL:
        return { ...state, loading: false, error: action.payload };
      case actionTypes.SAVE_SERVICE_VOLUNTEER_REQUEST:
        return { ...state, loading: true, error: null };

      case actionTypes.SAVE_SERVICE_VOLUNTEER_SUCCESS:
        return { ...state, loading: false };

      case actionTypes.SAVE_SERVICE_VOLUNTEER_FAIL:
        return { ...state, loading: false, error: action.payload };
        case actionTypes.FEATURED_CHURCHES_READ_REQUEST:
          return { ...state, featuredLoading: true, featuredError: null };
    
        case actionTypes.FEATURED_CHURCHES_READ_SUCCESS:
          return {
            ...state,
            featuredLoading: false,
            featuredChurches: action.payload?.data || [],
          };
    
        case actionTypes.FEATURED_CHURCHES_READ_FAIL:
          return { ...state, featuredLoading: false, featuredError: action.payload };
          case actionTypes.FAVOURITE_CHURCHES_READ_REQUEST:
            return { ...state, favouriteLoading: true, favouriteError: null };
      
          case actionTypes.FAVOURITE_CHURCHES_READ_SUCCESS:
            return {
              ...state,
              favouriteLoading: false,
              favouriteChurches: action.payload?.data || [],
            };
      
          case actionTypes.FAVOURITE_CHURCHES_READ_FAIL:
            return { ...state, favouriteLoading: false, favouriteError: action.payload };
          case actionTypes.HOME_CHURCHES_READ_REQUEST:
            return { ...state, homeLoading: true, homeError: null };
      
          case actionTypes.HOME_CHURCHES_READ_SUCCESS:
            return {
              ...state,
              homeLoading: false,
              homeChurches: action.payload?.data || [],
            };
      
          case actionTypes.HOME_CHURCHES_READ_FAIL:
            return { ...state, homeLoading: false, homeError: action.payload };
            case actionTypes.NEARBY_CHURCHES_READ_REQUEST:
              return { ...state, nearbyLoading: true, nearbyError: null };
        
            case actionTypes.NEARBY_CHURCHES_READ_SUCCESS:
              return {
                ...state,
                nearbyLoading: false,
                nearbyChurches: action.payload?.data || [],
              };
        
            case actionTypes.NEARBY_CHURCHES_READ_FAIL:
              return { ...state, nearbyLoading: false, nearbyError: action.payload };
              case actionTypes.UNLIKE_CHURCH_REQUEST:
  return { ...state, loading: true };

case actionTypes.UNLIKE_CHURCH_SUCCESS:
  return {
    ...state,
    loading: false,
    selectedChurch: action.payload?.data || state.selectedChurch,
  };

case actionTypes.UNLIKE_CHURCH_FAIL:
  return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default churchReducer;
